import axios from 'axios';
import { GET_EVALUABLE_EMPLOYEES_MONITOR, 
         IS_LOADING, 
         ERROR } from './actionsType';
import * as actions from './actionsType';
import messages from '../../messages';
import EmployeeEvaluableMonitorServices from './evaluableEmployeeMonitor.service';

export const getEvaluableEmployeeMonitor = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: IS_LOADING,
      payload: true,
    });
    const resp = await EmployeeEvaluableMonitorServices.getEvaluableEmployeeMonitor(filters);
    dispatch({
      type: GET_EVALUABLE_EMPLOYEES_MONITOR,
      payload: resp.data,
    });
    dispatch({
      type: ERROR,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          case 403:
            if (ex.response.data && ex.response.data.detail) {
              message = ex.response.data.detail;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: ERROR,
      payload: message,
    });
  } finally {
    dispatch({
      type: IS_LOADING,
      payload: false,
    });
  }
};